import { NavItem } from './general.known.routes';

/**
 * DON'T EVER CHANGE NUMERATION
 */
export enum ProviderKnownItemId {
  UPLOAD_REPS = 1,
  CONFIRM_REPS = 2,
  AGENCIA = 3,
  BASES = 4,
  ASSIGN_VEHICLE = 5,
  USER = 8,
  CONTRACTS = 9,
  PROVIDERS = 10,
  AMBULANCES = 12,
  OPERATION_COSTS = 13,
  MANAGE_VEHICLE = 14,
  VALIDATE_AVL = 15,
  SEND_VEHICLES_TO_ACTIVATE = 16,
  VEHICLES_TO_VALIDATE = 17,
  MANAGE_QR = 18,
  SEARCH_AND_REPORT_STATUS = 19,
  SECONDARY_TRANSFERS = 20,
  RETAINED_VEHICLE = 21,
  MANAGE_DEVICE_RESOURCE = 22,
  CONSULT_VEHICLE_TOOL_STOCK,
  CONSULT_BIOMEDICAL_EQUIPMENT_STOCK,
  CONSULT_MEDICINES_SUPPLIES,
  PROVIDER_LIST,
  APH_LOG,
}

const simpleTransformer = (input: NavItem): NavItem & { type: 'provider' } => {
  return {
    ...input,
    type: 'provider',
  };
};

export const ProvidersKnownRoutes = (k: ProviderKnownItemId): NavItem => {
  return JSON.parse(JSON.stringify(options[k]));
};

/**
 * DON'T EXPORT
 */
const options: {
  [k in ProviderKnownItemId]: NavItem & { type: 'provider' };
} = {
  [ProviderKnownItemId.UPLOAD_REPS]: simpleTransformer({
    id: ProviderKnownItemId.UPLOAD_REPS,
    displayName: 'Cargar Información REPS',
    route: '/home/providers/reps/upload',
    iconName: 'upload-file',
    parentModule: 'providers',
    allowFetchWithInclude: true,
  }),
  [ProviderKnownItemId.PROVIDERS]: simpleTransformer({
    id: ProviderKnownItemId.PROVIDERS,
    displayName: 'Prestadores',
    route: '/home/providers',
    iconName: 'providers',
    expanded: false,
    allowFetchWithInclude: false, // don't change
  }),
  [ProviderKnownItemId.PROVIDER_LIST]: simpleTransformer({
    id: ProviderKnownItemId.PROVIDER_LIST,
    displayName: 'Prestadores',
    iconName: 'providers',
    route: '/home/providers/list',
    parentModule: 'providers',
    allowFetchWithInclude: true,
  }),
  [ProviderKnownItemId.CONFIRM_REPS]: simpleTransformer({
    id: ProviderKnownItemId.CONFIRM_REPS,
    displayName: 'Confirmar Datos REPS',
    route: '/home/providers/confirm-data',
    iconName: 'task',
    parentModule: 'providers',
    allowFetchWithInclude: true,
  }),
  [ProviderKnownItemId.AGENCIA]: simpleTransformer({
    id: ProviderKnownItemId.AGENCIA,
    displayName: 'Gestionar Vehículos',
    route: '/home/providers/manageVehicle',
    iconName: 'ambulance',
    parentModule: 'providers',
    allowFetchWithInclude: true,
  }),
  [ProviderKnownItemId.MANAGE_VEHICLE]: simpleTransformer({
    id: ProviderKnownItemId.MANAGE_VEHICLE,
    displayName: 'Gestionar Vehículos',
    route: '/home/providers/manageVehicle',
    iconName: 'ambulance',
    parentModule: 'providers',
    allowFetchWithInclude: true,
  }),
  [ProviderKnownItemId.BASES]: simpleTransformer({
    id: ProviderKnownItemId.BASES,
    displayName: 'Gestionar Bases',
    route: '/home/providers/manageBases',
    iconName: 'bases',
    parentModule: 'providers',
    allowFetchWithInclude: true,
  }),
  [ProviderKnownItemId.ASSIGN_VEHICLE]: simpleTransformer({
    id: ProviderKnownItemId.ASSIGN_VEHICLE,
    route: '/home/providers/assignBases',
    iconName: 'bases',
    displayName: 'Asignar y trasladar vehículos',
    allowFetchWithInclude: true,
  }),
  [ProviderKnownItemId.SEND_VEHICLES_TO_ACTIVATE]: simpleTransformer({
    id: ProviderKnownItemId.SEND_VEHICLES_TO_ACTIVATE,
    route: '/home/providers/sendVehiclesToActivate',
    iconName: 'send',
    displayName: 'Enviar vehículos a C4',
    allowFetchWithInclude: true,
  }),
  [ProviderKnownItemId.VEHICLES_TO_VALIDATE]: simpleTransformer({
    id: ProviderKnownItemId.VEHICLES_TO_VALIDATE,
    route: '/home/providers/vehiclesToValidate',
    iconName: 'validate-vehicle',
    displayName: 'Validar vehículos visibles',
    allowFetchWithInclude: true,
  }),
  [ProviderKnownItemId.USER]: simpleTransformer({} as NavItem),
  [ProviderKnownItemId.CONTRACTS]: simpleTransformer({} as NavItem),
  [ProviderKnownItemId.AMBULANCES]: simpleTransformer({
    id: ProviderKnownItemId.AMBULANCES,
    displayName: 'Ambulancias',
    route: '',
    iconName: 'card',
  }),
  [ProviderKnownItemId.OPERATION_COSTS]: simpleTransformer({
    id: ProviderKnownItemId.OPERATION_COSTS,
    displayName: 'Costos de operación',
    route: '',
    iconName: 'tariff-groups',
  }),
  [ProviderKnownItemId.VALIDATE_AVL]: simpleTransformer({
    id: ProviderKnownItemId.VALIDATE_AVL,
    route: '/home/providers/validateAVL',
    iconName: 'radio-com',
    displayName: 'Validar Radio y AVL',
    allowFetchWithInclude: true,
    parentModule: 'providers',
  }),
  [ProviderKnownItemId.MANAGE_QR]: simpleTransformer({
    id: ProviderKnownItemId.MANAGE_QR,
    route: '/home/providers/manageQRCode',
    iconName: 'qr-code',
    displayName: 'Certificaciones de Servicios',
    allowFetchWithInclude: true,
    parentModule: 'providers',
  }),
  [ProviderKnownItemId.SEARCH_AND_REPORT_STATUS]: simpleTransformer({
    id: ProviderKnownItemId.SEARCH_AND_REPORT_STATUS,
    route: '/home/providers/searchAndReportStatus',
    iconName: 'ambulance',
    displayName: 'Reportar Estados de los Vehículos',
    allowFetchWithInclude: true,
    parentModule: 'providers',
  }),
  [ProviderKnownItemId.SECONDARY_TRANSFERS]: simpleTransformer({
    id: ProviderKnownItemId.SECONDARY_TRANSFERS,
    route: '/home/providers/secondary-transfers',
    iconName: 'social-distance',
    displayName: 'Traslados Secundarios',
    allowFetchWithInclude: true,
    parentModule: 'providers',
  }),
  [ProviderKnownItemId.RETAINED_VEHICLE]: simpleTransformer({
    id: ProviderKnownItemId.RETAINED_VEHICLE,
    route: '/home/providers/manageStretcher',
    iconName: 'ambulance',
    displayName: 'Consultar vehículos retenidos en IPS',
    allowFetchWithInclude: true,
    parentModule: 'providers',
  }),
  [ProviderKnownItemId.MANAGE_DEVICE_RESOURCE]: simpleTransformer({
    id: ProviderKnownItemId.MANAGE_DEVICE_RESOURCE,
    route: '/home/providers/manage-device-resource',
    iconName: 'burger-menu',
    displayName: 'Administrar dispositivos por recursos',
    allowFetchWithInclude: true,
    parentModule: 'providers',
  }),
  [ProviderKnownItemId.CONSULT_VEHICLE_TOOL_STOCK]: simpleTransformer({
    id: ProviderKnownItemId.CONSULT_VEHICLE_TOOL_STOCK,
    route: '/home/providers/vehicle-tool-stock',
    iconName: 'burger-menu',
    displayName: 'Consultar stock',
    allowFetchWithInclude: true,
    parentModule: 'providers',
  }),
  [ProviderKnownItemId.CONSULT_BIOMEDICAL_EQUIPMENT_STOCK]: simpleTransformer({
    id: ProviderKnownItemId.CONSULT_BIOMEDICAL_EQUIPMENT_STOCK,
    route: '/home/providers/biomedical-equipment-stock',
    iconName: 'burger-menu',
    displayName: 'Consultar stock',
    allowFetchWithInclude: true,
    parentModule: 'providers',
  }),
  [ProviderKnownItemId.CONSULT_MEDICINES_SUPPLIES]: simpleTransformer({
    id: ProviderKnownItemId.CONSULT_MEDICINES_SUPPLIES,
    route: '/home/providers/medicines-and-supplies-stock',
    iconName: 'burger-menu',
    displayName: 'Consultar stock',
    allowFetchWithInclude: true,
    parentModule: 'providers',
  }),
  [ProviderKnownItemId.APH_LOG]: simpleTransformer({
    id: ProviderKnownItemId.APH_LOG,
    route: '/home/providers/aph-log',
    iconName: 'group-dots',
    displayName: 'Registro APH',
    allowFetchWithInclude: true,
    parentModule: 'providers',
  }),
};
